import type { IconProps } from './types';

export function Lingerie({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M100 36 Q104 52 108 68 Q116 60 128 60 Q140 60 148 68 Q152 52 156 36 Q160 36 164 36 Q160 54 156 72 Q170 76 180 80 Q190 140 200 200 Q184 216 168 204 Q152 216 136 204 Q120 216 104 204 Q88 216 72 204 Q66 140 76 80 Q86 76 100 72 Q96 54 92 36 Q96 36 100 36 Z" />
    </svg>
  );
}
